import * as React from 'react';
import './riskQuestions.style.css';

import { BackNextSkip, Radiobutton } from '@assetmark/common-elements/';
import { ERiskPageType } from '../models/riskPageType';
import { TRiskProfile } from '../models/riskProfile.model';
import {
  countMaxDecline,
  formatLabel,
  GetRiskQuestions,
} from './riskQuestionsHelper';
import { TQuestionData } from '../models/riskQuestion.model';

export interface TRiskQuestionsProps {
  questionType: number;
  investmentAmount?: number;
  riskAnswer?: any;
  backButtonClassName?: string;
  nextButtonClassName?: string;
  backButtonText: string;
  nextButtonText: string;
  skipText?: string;
  riskProfiles?: TRiskProfile[];
  onRadioChange: (event: any) => void;
  onBackButtonClick: (event: any) => void;
  onNextButtonClick: (event: any) => void;
  onSkipClick?: (event: any) => void;
  questionData?: TQuestionData;
  highlighted?: boolean;
  highlightedRiskQuestions?: number;
}

export const RiskQuestionsComponent: React.StatelessComponent<
  TRiskQuestionsProps
> = ({
  questionType,
  investmentAmount,
  onRadioChange,
  riskAnswer,
  backButtonClassName,
  backButtonText,
  nextButtonClassName,
  nextButtonText,
  onBackButtonClick,
  onNextButtonClick,
  onSkipClick,
  skipText,
  riskProfiles,
  questionData,
  highlighted,
  highlightedRiskQuestions,
}) => {
  const riskQuestions = GetRiskQuestions(questionType);
  const choices =
    questionData && questionData.choices ? questionData.choices : [];
  return (
    <div className="risk-question col-sm-12">
      <h1 className="risk-question__heading"> {riskQuestions.Heading} </h1>
      <div className="row">
        <div className="col-sm-12">
          <p className="risk-question__question-text">
            {questionData.question}
          </p>
          <ul className="risk-question__question-options">
            {questionType === ERiskPageType.YourRiskProfile
              ? riskProfiles.map((riskProfile: TRiskProfile) => {
                  return (
                    <div
                      className={`risk-question__question-options ${highlighted &&
                        riskProfile.RiskProfileID <= highlightedRiskQuestions &&
                        'highlighted'}`}
                      key={riskProfile.RiskProfileID}
                    >
                      <Radiobutton
                        name="risk-tolerance"
                        value={riskProfile.RiskProfileID}
                        isChecked={
                          Number(riskAnswer) === riskProfile.RiskProfileID
                        }
                        onChange={onRadioChange}
                      >
                        {`${riskProfile.RiskProfileName} ${
                          riskProfile.RiskProfileType
                        }`}
                      </Radiobutton>
                    </div>
                  );
                })
              : choices.map((data) => {
                  let label;
                  switch (questionType) {
                    case Number([ERiskPageType.MaximumDecline]):
                      label = formatLabel(
                        countMaxDecline(
                          investmentAmount,
                          parseFloat(data.choice),
                        ),
                      );
                      break;
                    default:
                      label = data.choice;
                  }
                  return (
                    <li
                      key={data.choiceId}
                      className="risk-question__question-options"
                    >
                      <Radiobutton
                        name="risk-tolerance"
                        value={data.choiceId}
                        isChecked={riskAnswer === Number(data.choiceId)}
                        onChange={onRadioChange}
                      >
                        {label}
                      </Radiobutton>
                    </li>
                  );
                })}
          </ul>
          <div className="risk-question--buttons">
            <BackNextSkip
              backButtonClassName={backButtonClassName}
              backButtonText={backButtonText}
              onBackButtonClickHandler={onBackButtonClick}
              nextButtonClassName={nextButtonClassName}
              nextButtonText={nextButtonText}
              onNextButtonClickHandler={onNextButtonClick}
              //   skipText={skipText}
              //   onSkipClickHandler={onSkipClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
